import IsiForumAnak from "./src/IsiForumAnak";

export default IsiForumAnak